import { api, RouterOutput } from "../../../services/rpc/RpcProvider";
import { useCallback } from "react";
import { useToast } from "@introist/react-foundation/v2";

export type DataSource = RouterOutput["employees"]["dataSources"]["list"][0];

export const useDataSources = (sourceTypes?: string[]) => {
  const { data: dataSources } = api.employees.dataSources.list.useQuery({});

  return {
    dataSources: sourceTypes
      ? dataSources?.filter(_ => sourceTypes.includes(_.sourceType))
      : dataSources
  };
};

export const useDataSourceActions = () => {
  const toast = useToast();
  const scanOp = api.employees.dataSources.scan.useMutation();

  const apiUtils = api.useContext();
  const listOp = apiUtils.employees.dataSources.list;

  const scanGroup = useCallback(
    async (dataSourceId: string, throwError = false) => {
      return scanOp
        .mutateAsync({ dataSourceId })
        .then(async () => {
          await listOp.refetch();
          toast.success("Data source group scanned");
        })
        .catch(err => {
          toast.error("Failed to scan data source group");
          if (throwError) throw err;
        });
    },
    [scanOp, toast, listOp]
  );

  return { scanGroup };
};
